import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import _wrapNativeSuper from '@babel/runtime/helpers/wrapNativeSuper';
import { t } from '@kso/ui/lib/config/locale';

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ExportErrorExceptionMap = {
  ImageResourcesTooLarge: t('logic.FileDownload.imageResourcesTooLarge'),
  TooManyRequests: t('logic.FileDownload.tooManyRequests'),
  permissionDenied: t('logic.FileDownload.permissionDenied'),
  VisiblePermissionDenied: t('logic.FileDownload.VisiblePermissionDenied')
};
var AsyncExportException = /*#__PURE__*/function (_Error) {
  function AsyncExportException() {
    var _this;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, AsyncExportException);
    _this = _callSuper(this, AsyncExportException, ['']);
    var _ref = data || {},
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? '' : _ref$error,
      _ref$response = _ref.response,
      response = _ref$response === void 0 ? {} : _ref$response;
    _this.response = response;
    _this.message = ExportErrorExceptionMap[error] || t('logic.FileDownload.fail');
    return _this;
  }
  _inherits(AsyncExportException, _Error);
  return _createClass(AsyncExportException);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { AsyncExportException, ExportErrorExceptionMap };
